module.exports = __webpack_public_path__ + "img/logo5.d77b470d.png";